import React from 'react';
import { 
  RocketLaunchIcon, 
  UserIcon,
  UsersIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import StageCards from '../../../components/playbooks/StageCards';
import { getPlaybookById } from '../../../data/playbookTaxonomy';

// Stage icons mapping
const stageIcons = {
  'stage-1': <UserIcon className="h-6 w-6" />,
  'stage-2': <UsersIcon className="h-6 w-6" />,
  'stage-3': <ChartBarIcon className="h-6 w-6" />
};

const WorkingThroughConflictHowToExecute = () => {
  // Get stage sections from the taxonomy
  const playbook = getPlaybookById('working-through-conflict');
  const stageSections = playbook?.sections.filter(section => section.id.startsWith('stage-')) || [];

  return (
    <div className="space-y-8">
      <PlaybookSection title="How To Execute" icon={<RocketLaunchIcon className="h-7 w-7 text-primary-light" />} heading>
        <div className="prose prose-invert max-w-none mb-8">
          <p className="text-gray-300">
            Clicking into each tile, you will find a mini toolkit for each of the common kinds of conflict you might need to navigate. If you have any questions or need help.{' '}
          </p>
        </div>
        
        <StageCards 
          stages={stageSections}
          icons={stageIcons}
          playbookId="working-through-conflict"
          introText="Three scenario-based toolkits to help you navigate different types of conflict in your organization."
        />

       
      </PlaybookSection>
    </div>
  );
};

export default WorkingThroughConflictHowToExecute; 